import React, { PureComponent, RefObject } from 'react';
import { NetworkMonitoringFlowsComponent } from './NetworkMonitoringFlows';
import {
    ConfiguredAirspace,
    CoordinationSummary,
    ExtendedMonitoredTv,
    MonitoredEvent,
    MonitoredMcdmMeasure,
    MonitoredMeasure,
    NetworkMapConvection,
    TvMeteoAlert,
    TvSetForecastProgress,
} from 'app/model/SOL49';
import { FlightDto, FlightId, TimePeriod } from 'app/model/CORE';
import Utils from '../../../common/util/Utils';
import { MapSettings } from './map/MapSettings';
import { MeasuresSettings } from 'app/components/dashboard/detailed/measures/MeasuresSettings';

export interface NetworkMonitoringProps {
    monitoredPeriod: TimePeriod;
    filteredTvIds?: Array<string>;
    monitoredTvs: Array<ExtendedMonitoredTv>;
    tvSetMap?: { [key: string]: string };
    tvSetProgressMap?: { [key: string]: TvSetForecastProgress };
    tvSetlastUpdate?: { [key: string]: Date };
    monitoredMeasures: Array<MonitoredMeasure>;
    monitoredMcdmMeasures: Array<MonitoredMcdmMeasure>;
    monitoredEvents?: Array<MonitoredEvent>;
    coordinationSummaries: Array<CoordinationSummary>;
    tvsOccupancyPeriods?: { [key: string]: Map<FlightId, TimePeriod> };
    configuredAirspaces?: Array<ConfiguredAirspace>;
    currentTime: Date;
    textFilter: string;
    onTextFilterChange?(value: string): void;
    selectedTvs: ExtendedMonitoredTv[];
    onSelectionChange?(tvs: Array<ExtendedMonitoredTv>);
    selectedFlights: FlightDto[];
    onMapSettingsChanged(mapSettings: MapSettings): void;
    convectionData: NetworkMapConvection;
    // convectionAirspaceDef: { [key : string] : CORE.Airspace }
    mapSettings: MapSettings;
    tvMeteoAlerts?: { [key: string]: Array<TvMeteoAlert> };
    globalFilterEnabled: boolean;
    onGlobalFilterEnabledChanged(filterEnabled: boolean): void;
    dashboardDataVersion: number;
    measureSettings: MeasuresSettings;
}

export interface NetworkMonitoringState {}

export abstract class NetworkMonitoring<
    P extends NetworkMonitoringProps,
    S extends NetworkMonitoringState,
> extends PureComponent<P, S> {
    flowsComponentRef: RefObject<NetworkMonitoringFlowsComponent> = React.createRef<NetworkMonitoringFlowsComponent>();

    constructor(props) {
        super(props);
    }

    /*
     * Function that allows to retrieve all displayed TVs in sub-components, including text filtering and particular filter settings.
     * This is used by the select all function to select all visible TVs.
     */
    getDisplayedMonitoredTvs = (): Array<ExtendedMonitoredTv> => {
        return this.flowsComponentRef?.current?.getDisplayedMonitoredTvs();
    };

    handleSelectionChange = (tvs: Array<ExtendedMonitoredTv>, selected: boolean) => {
        const newSelection = selected
            ? Utils.copyAndAddAllIfNeeded(this.props.selectedTvs, tvs)
            : Utils.copyAndRemoveAllIfNeeded(this.props.selectedTvs, tvs);
        this.props.onSelectionChange?.(newSelection);
    };

    handleSelectAll = () => {
        this.handleSelectionChange(this.getDisplayedMonitoredTvs(), true);
    };

    handleClearSelection = () => {
        this.props.onSelectionChange?.([]);
    };

    handleMapSettingsChanged = (settings: MapSettings) => {
        this.props.onMapSettingsChanged(settings);
    };
}
